export default __webpack_public_path__ + "static/firestick-8273g-a730ce30675fd35e2a0ff7b9e489424a.png";